import React from "react";
import { Card, Progress, Popover, Icon } from "antd";
import { getPresenceScoreColor } from "./utils";

const { Meta } = Card;
type Props = {
    presenceScore: number;
}

export default function PresenceScore({ presenceScore }: Props) {
    // The card says nothing about which assistant answered: the tab above the report already
    // does, and the score is read the same way whichever assistant it came from.
    return (
        <Card
            type="inner"
            className="presence-score-card"
            title={
                <Meta
                    title={
                        <div className="presence-score-title">
                            AI Presence Score
                            <Popover
                                placement="leftTop"
                                overlayStyle={{ maxWidth: '360px' }}
                                content={
                                    <div>
                                        The percentage of questions where the AI assistant recommends this website. Every website in the <strong>Top websites</strong> list
                                        is scored the same way, so they can be compared directly.
                                    </div>}
                            >
                                <Icon className="tooltip" type="question-circle" theme="filled" />
                            </Popover>
                        </div>
                    }
                    description={"How often a website appears in AI answers"}
                />
            }
        >
            <div className="presence-score-container">
                <div className="presence-score">
                    <Progress
                        type="circle"
                        percent={presenceScore}
                        strokeWidth={6}
                        width={100}
                        strokeColor={getPresenceScoreColor(presenceScore)}
                        format={(percent) => `${percent}/100`}
                    />
                </div>
            </div>
        </Card>
    );
}
